import Constants from '../actions/types';
import { removeMilliseconds } from '../utils';
import { Logger } from 'react-logger-lib';

const initialState = {
  entities: [],
  loading: false,
  error: null,
  selected: null
};

const entityReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.ENTITIES_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };
      Logger.of('App.reducer.entityReducer').info('GET_REQUEST', newState);
      return newState;
    }

    case Constants.ENTITIES_GET_SUCCESS: {
      const data = action.payload.map(value => removeMilliseconds(value));
      const newState = {
        ...state,
        entities: data,
        selected: !state.selected && data ? data[0] : state.selected || null,
        loading: false
      };

      return newState;
    }

    case Constants.ENTITIES_GET_FAILURE: {
      const newState = {
        ...state,
        entities: [],
        error: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.ENTITIES_SAVE_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.ENTITIES_ADD_SUCCESS: {
      const newEntities = [...state.entities, action.payload];
      const newState = {
        ...state,
        entities: newEntities,
        loading: false
      };

      return newState;
    }

    case Constants.ENTITIES_ADD_FAILURE: {
      const newState = {
        ...state,
        error: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.ENTITIES_DELETE_SUCCESS: {
      const selectedEntity = state.entities.find(
        entity => entity.entityVersionId === action.payload.entityVersionId
      );
      const index = state.entities.indexOf(selectedEntity);
      const newEntities = [].concat(
        state.entities.slice(0, index),
        state.entities.slice(index + 1)
      );
      const newState = {
        ...state,
        entities: newEntities,
        loading: false,
        selected: newEntities[0] ? newEntities[0] : null
      };

      return newState;
    }

    case Constants.ENTITIES_DELETE_FAILURE: {
      const newState = {
        ...state,
        error: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.ENTITY_SELECT: {
      const newState = {
        ...state,
        selected: action.payload
      };

      return newState;
    }

    case Constants.ENTITIES_CLEARERROR: {
      const newState = {
        ...state,
        error: null
      };

      return newState;
    }

    case Constants.ENTITIES_SAVE_SUCCESS: {
      const selectedEntity = state.entities.find(
        entity => entity.entityVersionId === action.payload.entityVersionId
      );
      const index = state.entities.indexOf(selectedEntity);
      const newEntities = [].concat(
        state.entities.slice(0, index),
        action.payload,
        state.entities.slice(index + 1)
      );
      const newState = {
        ...state,
        entities: newEntities,
        loading: false
      };

      return newState;
    }

    case Constants.ENTITIES_SAVE_FAILURE: {
      const newState = {
        ...state,
        error: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.ENTITIES_REPLACE_MATCHING_FAILURE: {
      const newState = {
        ...state,
        error: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.ENTITY_RECORDS_EXPORT_FAILURE: {
      const newState = {
        ...state,
        error: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.ENTITY_CONFIG_EXPORT_FAILURE: {
      const newState = {
        ...state,
        error: action.payload,
        loading: false
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default entityReducer;
